var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIpmIconDownload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.36 20.778a.576.576 0 0 0 .09-.09l3.801-4.752a.576.576 0 0 0-.45-.936H16.25l.001-8.174a.576.576 0 0 0-.576-.576h-1.348a.576.576 0 0 0-.576.576L13.749 15h-2.55a.576.576 0 0 0-.45.936l3.801 4.752a.576.576 0 0 0 .81.09z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 19v2.598c0 .636.516 1.152 1.152 1.152h14.196c.636 0 1.152-.516 1.152-1.152V19H26v4.272c0 .954-.774 1.728-1.728 1.728H5.728A1.728 1.728 0 0 1 4 23.272V19h2.75z",
    fill: "#1B7690"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIpmIconDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ipm-icon-download.70f9d8778a65fc9e66058f200278d5fd.svg";